// /components/DietAssessment/components/AssessmentStep.js

import React from 'react';
import { Button, Box, useMediaQuery, useTheme } from '@mui/material';

export const AssessmentNextStepButton = ({ nextAllowed = false, stepInfo = {}, onSubmit }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleSubmit = () => {
    onSubmit();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        position: isMobile ? 'fixed' : 'static',
        bottom: isMobile ? 0 : 'auto',
        left: 0,
        padding: isMobile ? '0 0 80px 0' : 0,
        backgroundColor: isMobile ? 'background.paper' : 'transparent',
        zIndex: 1000,
      }}
    >
      <Button
        disabled={!nextAllowed}
        variant="contained"
        onClick={handleSubmit}
        sx={{
          p: 2,
          mb: 2,
          width: '90%',
          maxWidth: '500px',
        }}
      >
        {stepInfo?.next_button_label || 'Next'}
      </Button>
    </Box>
  );
};
